<template>
    
        <v-row justify="center">
            <v-col cols="12" xl="10">
                <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

                    <div class="watermark">
                        <img v-if="invoiceHeader" :src="getFileServerUrl + ttAllocationData?.branch?.company?.watermark" alt="">
                        <!-- <img v-if="invoiceHeader" src="http://127.0.0.1:8000/uploads/images/company/watermark/watermark_696c9d915465b.png" alt=""> -->
                    </div>

                    <div class="letter-container">
                        <div class="letter-content">
                            <table style="width: 100%; border-collapse: collapse;">
                                <thead>
                                    <tr v-if="invoiceHeader">
                                        <td colspan="100%">
                                        <img :src="getFileServerUrl + ttAllocationData?.branch?.company?.header_image" style="width: 100%; height: auto;" alt="">
                                        </td>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    <tr>
                                        <td colspan="100%" style="border: none; padding: 25px; vertical-align: top;">
                                            <div style="font-family: sans-serif; font-size: 9px; line-height: 1.6;">
                                                
                                                <div style="margin-bottom: 10px;">
                                                    <p style="margin: 0;">Date: {{ formattedDate(new Date) }}</p>
                                                    <p style="margin: 0;">To</p>
                                                    <p style="margin: 0;">Head of Corporate,</p>
                                                    <!-- <p style="margin: 0;">{{ ttAllocationData?.buying_house_bank?.name }},</p>
                                                    <p style="margin: 0;">{{ ttAllocationData?.buying_house_bank?.address }}</p> -->
                                                    <p style="margin: 0;">Meghna Bank Limited,</p>
                                                    <p style="margin: 0;">Gulshan, Dhaka.</p>
                                                </div>

                                                <div style="margin-bottom: 10px;">
                                                    <p style="margin: 0;">Attn: Sohel Mahmood, Associate Relationship Manager, Corporate Banking Division.</p>
                                                </div>

                                                <div style="margin-bottom: 10px; display: flex; gap: 5px;">
                                                    <p style="margin: 0;">Subject: </p>
                                                    <p style="margin: 0;">Allocation of export proceeds against sales contract <strong> {{ ttAllocationData?.master_sales_contact?.code }}</strong></p>
                                                </div>

                                                <div style="margin-bottom: 6px;">
                                                    <p style="margin: 0;">Dear Sir,</p>
                                                </div>

                                                <div style="margin-bottom: 20px;">
                                                    <p style="margin: 0 0 12px 0; text-align: justify;">
                                                        We would like to inform you that we have received 100% payment via FTT against below quoted export proceed:
                                                    </p>

                                                    <table style="width: 100%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; width: 50%;">Buyer Name</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.buyer?.name }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; ">Buyer's Bank Name</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">{{ ttAllocationData?.buyer?.bank_info?.[0]?.bank_name }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">Sales Contact Ref & Date</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;  font-weight: bold;">{{ ttAllocationData?.master_sales_contact?.code }}, {{ formattedDate(ttAllocationData?.master_sales_contact?.created_at) }}  </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table style="width: 100%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: left; font-weight: bold;">FTT Reference</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">TT Utilization Amount</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">1st Beneficiary</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">2nd Beneficiary</td>
                                                                <td v-if="ttAllocationData?.details?.third_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">4th Beneficiary</td>
                                                                <td v-if="ttAllocationData?.details?.fourth_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">4th Beneficiary</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">{{ ttAllocationData?.details?.ftt_reference }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">${{ ttAllocationData?.details?.tt_utilization_amount }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">${{ ttAllocationData?.details?.first_beneficiary_amount }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;">${{ ttAllocationData?.details?.second_beneficiary_amount }}</td>
                                                                <td v-if="ttAllocationData?.details?.third_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center;">${{ ttAllocationData?.details?.third_beneficiary_amount }}</td>
                                                                <td v-if="ttAllocationData?.details?.fourth_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center;">${{ ttAllocationData?.details?.fourth_beneficiary_amount }}</td>
                                                            </tr>
                                                            <tr style="height: 20px;">
                                                                <td style="border: 1px solid #000; padding: 1px 4px;"></td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;"></td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;"></td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center;"></td>
                                                                <td v-if="ttAllocationData?.details?.third_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center;"></td>
                                                                <td v-if="ttAllocationData?.details?.fourth_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center;"></td>
                                                            </tr>
                                                            <tr style="background-color: #f0f0f0;">
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">Total(USD)</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">${{ ttAllocationData?.details?.tt_utilization_amount }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">${{ ttAllocationData?.details?.first_beneficiary_amount }}</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">${{ ttAllocationData?.details?.second_beneficiary_amount }}</td>
                                                                <td v-if="ttAllocationData?.details?.third_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">${{ ttAllocationData?.details?.third_beneficiary_amount }}</td>
                                                                <td v-if="ttAllocationData?.details?.fourth_beneficiary_amount" style="border: 1px solid #000; padding: 1px 4px; text-align: center; font-weight: bold;">${{ ttAllocationData?.details?.fourth_beneficiary_amount }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    
                                                    <p style="margin: 0 0 12px 0; text-align: justify;">
                                                        This payment has been received as advance against the subject sales contract. Please arrange to implement the subject payment as per our allocation (amount for 1st beneficiary) against our submitted “Form- C” and pay to factory (amount as 2nd{{  beneficiaryTextShow(ttAllocationData?.details?.third_beneficiary, ttAllocationData?.details?.fourth_beneficiary) }} beneficiary) as below details:
                                                    </p>

                                                    <table style="width: 100%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; width: 50%;">2nd Beneficiary Name</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.second_beneficiary?.supplier_name }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">2nd Beneficiary Contract Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.second_beneficiary?.supplier_email }}/ {{ ttAllocationData?.details?.second_beneficiary?.supplier_mobile }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">2nd Beneficiary Invoice Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.second_beneficiary?.code }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">2nd Beneficiary Bank Info</td>
                                                                <td>
                                                                    <table style="border-collapse: collapse; width: 100%; font-weight: bold;">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">Bank Name: {{ ttAllocationData?.details?.second_beneficiary?.bank_info?.[0]?.bank_name }}, Branch: {{ ttAllocationData?.details?.second_beneficiary?.bank_info?.[0]?.branch_name }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">A/C No: {{ ttAllocationData?.details?.second_beneficiary?.bank_info?.[0]?.ac_number }}, SWIFT Code: {{ ttAllocationData?.details?.second_beneficiary?.bank_info?.[0]?.swift_code }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding: 1px 4px;">A/C Title Name: {{ ttAllocationData?.details?.second_beneficiary?.bank_info?.[0]?.account_holder_name }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table v-if="ttAllocationData?.details?.third_beneficiary" style="width: 100%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; width: 50%;">3rd Benefiary Name</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.third_beneficiary?.supplier_name }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">3rd Beneficiary Contract Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.third_beneficiary?.supplier_email }}/ {{ ttAllocationData?.details?.third_beneficiary?.supplier_mobile }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">3rd Beneficiary Invoice Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.third_beneficiary?.code }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">3rd Beneficiary Bank Info</td>
                                                                <td>
                                                                    <table style="border-collapse: collapse; width: 100%; font-weight: bold;">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">Bank Name: {{ ttAllocationData?.details?.third_beneficiary?.bank_info?.[0]?.bank_name }}, Branch: {{ ttAllocationData?.details?.third_beneficiary?.bank_info?.[0]?.branch_name }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">A/C No:  {{ ttAllocationData?.details?.third_beneficiary?.bank_info?.[0]?.ac_number }}, SWIFT Code: {{ ttAllocationData?.details?.third_beneficiary?.bank_info?.[0]?.swift_code }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding: 1px 4px;">A/C Title Name: {{ ttAllocationData?.details?.third_beneficiary?.bank_info?.[0]?.account_holder_name }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table v-if="ttAllocationData?.details?.fourth_beneficiary" style="width: 100%; border-collapse: collapse; margin: 10px auto; border: 1px solid #000;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; width: 50%;">4th Benefiary Name</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.fourth_beneficiary?.supplier_name }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">4th Beneficiary Contract Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.fourth_beneficiary?.supplier_email }}/ {{ ttAllocationData?.details?.fourth_beneficiary?.supplier_mobile }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">4th Beneficiary Invoice Ref</td>
                                                                <td style="border: 1px solid #000; padding: 1px 4px; font-weight: bold;">{{ ttAllocationData?.details?.fourth_beneficiary?.code }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 1px 4px;">4th Beneficiary Bank Info</td>
                                                                <td>
                                                                    <table style="border-collapse: collapse; width: 100%; font-weight: bold;">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">Bank Name: {{ ttAllocationData?.details?.fourth_beneficiary?.bank_info?.[0]?.bank_name }}, Branch: {{ ttAllocationData?.details?.fourth_beneficiary?.bank_info?.[0]?.branch_name }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="border-bottom: 1px solid #000; padding: 1px 4px;">A/C No:  {{ ttAllocationData?.details?.fourth_beneficiary?.bank_info?.[0]?.ac_number }}, SWIFT Code: {{ ttAllocationData?.details?.fourth_beneficiary?.bank_info?.[0]?.swift_code }}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style="padding: 1px 4px;">A/C Title Name: {{ ttAllocationData?.details?.fourth_beneficiary?.bank_info?.[0]?.account_holder_name }}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <p style="margin: 4px 0 4px 0;">We are assuring the authenticity of above information and relevant documents and also expecting your cooperation to release the subject payment at earliest.</p>
                                                </div>

                                                <div style="margin-bottom: 10px;">
                                                    <p style="margin: 0;">Thank you,</p>
                                                    <p style="margin: 0;">Name of Client: {{ ttAllocationData?.branch?.company?.company_owner_name }},</p>
                                                    <!-- <p style="margin: 0;">A/C: {{ ttAllocationData?.buying_house_bank?.account_no }}</p> -->
                                                    <p style="margin: 0;">A/C: <strong>112011200000073</strong></p>
                                                </div>

                                                <div :style="{marginBottom: '30px', marginTop: '-20px', paddingTop: !withSignature ? '60px' : '0'}">
                                                    <img v-if="withSignature" :src="`${getFileServerUrl}` + 'uploads/images/company/signature-without-bg.png'" style="width: 160px; height: 50px;" alt="">
                                                    <div style="border-bottom: 1px solid #000; margin: 0 0 8px 0; width: 160px; margin-top: -15px;"></div>
                                                    <div style="font-weight: bold; font-size: 9px;">Authorized signature</div>
                                                    <!-- <p style="margin: 5px 0 0 0;"><strong>{{ employeeDetails?.branch?.company?.company_owner_name }}</strong></p>
                                                    <p style="margin: 0;"><strong>{{ employeeDetails?.branch?.company?.owner_designation?.name }}</strong></p>
                                                    <p style="margin: 0;"><strong>{{ employeeDetails?.branch?.company?.name }}</strong></p> -->
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr v-if="invoiceHeader">
                                        <td colspan="100%" style="border:none">
                                        <div style="width:100%;height: 100px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tfoot>

                            </table>
                        </div>

                        <div class="invoice-footer">
                            <img v-if="invoiceHeader" :src="getFileServerUrl + ttAllocationData?.branch?.company?.footer_image" alt="" style="width: 100%; display: block; margin-bottom:-15px;">
                            <!-- <img v-if="invoiceHeader" src="http://127.0.0.1:8000/uploads/images/company/footer/footer_696c9d9154010.png" alt="" style="width: 100%; display: block; margin-bottom:-15px;"> -->
                        </div>
                    </div>

                </v-sheet>
            </v-col>
            <v-col cols="12">
                <v-checkbox
                label="With signature"
                v-model="withSignature"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                :true-value="1"
                :false-value="0"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" style="display: flex; justify-content: end; padding: 0 35px;" >
                <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
                    Print without pad
                </v-btn>
                <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
                    Print with pad
                </v-btn>
            </v-col>
        </v-row>
    
</template>

<script>
import formattedDate from '@/plugins/dateFormatter';

export default {
    name: "hrm-employee-appointment-letter",
    props: {},
    data() {
        return {
            withSignature :1,
            leaveTypesData: null,
            invoiceHeader: true,
            ttAllocationData: null,
            pagePadding: 0,
        };
    },
    created() {
        if (!this.$store.getters.getHrmEmployeeSalaryDistribution) {
            this.$store.dispatch("getHrmEmployeeSalaryDistribution");
        }
    },
    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
        getSalaryDistro() {
            const salaryDistro = this.$store.getters.getHrmEmployeeSalaryDistribution;
            return salaryDistro;
        },
    },
    methods: {
        formattedDate,
        beneficiaryTextShow(thirdBeneficiary, fourthBeneficiary) {
            if (thirdBeneficiary && fourthBeneficiary) {
                return ", 3rd and 4th";
            } else if (thirdBeneficiary) {
                return " and 3rd";
            } else if(fourthBeneficiary){
                return " and 4th";
            } else {
                return "";
            }
        },
        print(isPad) {
            if (isPad === 1) {
                this.invoiceHeader = true;
                this.pagePadding = 0;
            } else if (isPad === 0) {
                this.invoiceHeader = false;
                this.pagePadding = 80;
            }

            setTimeout(() => {
                
                const printContent = document.getElementById("printable-area").innerHTML;
                const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
    
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>TT Allocation</title>
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
    
                    @page {
                        size: A4;   
                        margin: ${pagePadding.value}px 0;
                    }

                    html, body {
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: auto;
                    }
    
                    body { 
                        font-family: sans-serif; 
                        background: #fff; 
                        color: #000; 
                        -webkit-print-color-adjust: exact; 
                        print-color-adjust: exact;
                        margin: 0;
                        padding: 0;
                    }
    
                    .report-paper { 
                        width: 100%; 
                        padding: 0 !important;
                        background: #fff;
                        margin: 0;
                    }
    
                    .letter-container {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                    }
    
                    .letter-content {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        overflow: visible;
                    }
    
    
                    table {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        border-collapse: collapse;
                    }
    
                    thead {
                        display: table-header-group;
                        page-break-inside: avoid;
                    }
    
                    .invoice-footer {
                        margin-top: auto;
                        position: fixed;
                        left; 0;
                        bottom: 15px;
                        width: 100%;    
                    }
    
                    tbody {
                        page-break-inside: avoid;
                    }
    
                    .watermark {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 0;
                    }
    
                    img { 
                        max-width: 100% !important; 
                        height: auto !important; 
                        display: block;
                    }
    
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-left { text-align: left; }
                    
                    .mt-4 { margin-top: 16px !important; }
                    .pa-6 { padding: 24px !important; }
    
                    .d-print-none {
                        display: none !important;
                    }
    
                    @media print { 
                        body {
                            margin: 0;
                            padding: 0;
                        }
    
                        .report-paper {
                            margin: 0;
                            padding: 0;
                        }
    
                        thead {
                            display: table-header-group;
                            page-break-inside: avoid;
                            page-break-after: avoid;
                        }
    
                        tfoot {
                            display: table-footer-group;
                            page-break-inside: avoid;
                            page-break-before: avoid;
                        }
    
                        tbody {
                            page-break-inside: avoid;
                        }
    
                        table {
                            page-break-inside: auto;
                        }
    
                        tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
    
                        .watermark {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            z-index: 0;
                        }
                    }
                    </style>
                    </head>
                    <body>
                        ${printContent}
                    </body>
                    </html>
                `);
    
                printWindow.document.close();
                printWindow.focus();

                setTimeout(() => {
                    printWindow.print()
                }, 500);
                this.invoiceHeader = true;
                this.pagePadding = 0;
            }, 500);
        }
    },
    mounted() {
      const id = this.$route.params.id;

      this.$store.dispatch("getTtAllocation", id)
      .then((res) => {
        this.ttAllocationData = res;
        console.log(this.ttAllocationData);
      })  
    },
};
</script>

<style scoped>
body, html {
    font-family: sans-serif;
}
.full-height { 
    min-height: 60vh; 
}
.grey-lighten-3 { 
    background-color: #eeeeee !important; 
}
.report-paper { 
    background: white; 
}
.letter-container { 
    width: 100%; 
}
.text-center { 
    text-align: center; 
}
.text-right { 
    text-align: right; 
}
.text-left { 
    text-align: left; 
}
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.justify-end{
    justify-content:flex-end;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>